import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from '../forms/input-control.base';

@Component({
    selector: 'app-time-box',
    templateUrl: './time-box.component.html',
    styleUrls: ['./time-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimeBoxComponent extends InputControlBase {
  constructor() {
    super();
  }
}
